import React, { useMemo } from 'react';

export default function GratificacionConsuModal({
  isOpen,
  onClose,
  onRecalcular,
  empleados = [],
  planillaNombre,
  planillaCerrada = false,
  guardando = false,
  recalculando = false,
  periodoGratiConsuDe,
  etiquetaPeriodoGratiConsu,
  onCambiarPeriodo,
}) {
  const empleadosOrdenados = useMemo(
    () =>
      [...empleados].sort((a, b) =>
        String(a.nombre_completo || a.nombre || '').localeCompare(
          String(b.nombre_completo || b.nombre || ''),
          'es'
        )
      ),
    [empleados]
  );

  const cantidadForzada = empleadosOrdenados.filter(
    (emp) => periodoGratiConsuDe(emp.id) !== 'auto'
  ).length;

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
        <div className="bg-orange-600 text-white p-8">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-xl font-bold">Gratificación construcción civil</h2>
              <p className="text-orange-100 text-sm mt-1">
                Planilla: {planillaNombre || '—'} | {empleadosOrdenados.length} trabajador(es)
              </p>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="text-white hover:text-orange-100 transition-colors text-2xl leading-none"
              aria-label="Cerrar"
            >
              ×
            </button>
          </div>
        </div>

        <div className="p-8 overflow-y-auto max-h-[calc(90vh-200px)]">
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-6 mb-6">
            <p className="text-orange-900 text-sm">
              Elige por trabajador si se usa el cálculo de enero–julio (÷7) o el de agosto–diciembre (÷5).
              Por defecto septiembre usa Navidad. Si la empresa todavía paga con Fiestas Patrias, cámbialo aquí
              y vuelve a generar la planilla.
            </p>
          </div>

          {cantidadForzada > 0 && (
            <div className="mb-4">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800 border border-orange-200">
                {cantidadForzada} trabajador(es) con periodo distinto al de las fechas
              </span>
            </div>
          )}

          <div className="overflow-x-auto border border-gray-200 rounded-lg">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50 text-gray-600">
                <tr>
                  <th className="text-left px-4 py-3 font-medium">Trabajador</th>
                  <th className="text-left px-4 py-3 font-medium">Cálculo de gratificación</th>
                </tr>
              </thead>
              <tbody>
                {empleadosOrdenados.map((emp) => {
                  const valor = periodoGratiConsuDe(emp.id);
                  return (
                    <tr key={emp.id} className="border-t border-gray-100">
                      <td className="px-4 py-3">
                        <div className="font-medium text-gray-900">
                          {emp.nombre_completo || emp.nombre || 'Empleado'}
                        </div>
                        <div className="text-xs text-gray-500">
                          {emp.numero_documento || emp.documento || emp.dni || ''}
                          {valor !== 'auto' ? ` · ${etiquetaPeriodoGratiConsu(valor)}` : ''}
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <select
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 bg-white"
                          value={valor}
                          disabled={guardando || planillaCerrada}
                          onChange={(e) => onCambiarPeriodo(emp.id, e.target.value)}
                        >
                          <option value="auto">{etiquetaPeriodoGratiConsu('auto')}</option>
                          <option value="fp">Fiestas Patrias (ene–jul, ÷7)</option>
                          <option value="navidad">Navidad (ago–dic, ÷5)</option>
                        </select>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="px-8 py-4 border-t border-gray-200 bg-gray-50 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={guardando || recalculando}
            className="px-5 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
          >
            Cerrar
          </button>
          <button
            type="button"
            disabled={guardando || recalculando || planillaCerrada}
            onClick={async () => {
              onClose();
              if (onRecalcular) await onRecalcular();
            }}
            className="px-5 py-2 text-sm font-medium text-white bg-orange-600 rounded-lg hover:bg-orange-700 disabled:opacity-50"
          >
            {recalculando ? 'Recalculando…' : 'Salir y recalcular'}
          </button>
        </div>
      </div>
    </div>
  );
}
